
import { overrideStore, parametrize } from 'react-overridable';

import DatasetsResultsListItem from '@js/datasets/search/ResultsListItem';
import { ResultsListItemWithState } from '@components_common/components/items/GlobalSearchResultListItem.jsx';
import External_datasetsResultsListItem from '@js/external_datasets/search/ResultsListItem';
import { ClearableSearchbarElement } from '@js/oarepo_ui/search/ClearableSearchbarElement';


overrideStore.add('InvenioAppRdm.Search.ResultsList.item.local://datasets-v1.0.0.json', DatasetsResultsListItem);
overrideStore.add('InvenioAppRdm.Search.ResultsList.item', ResultsListItemWithState);
overrideStore.add('InvenioAppRdm.Search.ResultsList.item.local://external_datasets-v1.0.0.json', External_datasetsResultsListItem);
overrideStore.add('InvenioAppRdm.Search.SearchBar.element', ClearableSearchbarElement);
